module.exports = __webpack_public_path__ + "static/casque1-75e97719803a480b3fe7e6e30fac7a8b.jpg";